module.exports = __webpack_public_path__ + "img/sel_Hangzhou-.18f8ec0f.png";